export enum ConversationDetailsTabs {
  ConversationDetails = 'conversation-details',
  MeetingNotes = 'meeting-notes'
}

export const conversationDetailsTabs = [
  {
    label: 'Conversation',
    value: ConversationDetailsTabs.ConversationDetails
  },
  {
    label: 'Meeting Notes',
    value: ConversationDetailsTabs.MeetingNotes
  }
];
